<template>
  <div class="product-detail-card">
    <div class="product-name">{{ flower.flower_specie.flower_genus.name }}</div>
    <div class="product-name-lg">{{ flower.flower_specie.name }}</div>

    <v-divider />

    <div class="d-flex my-3 align-center">
      <strong class="number ml-2 product-lowest-price">
        ¥{{ $n(flower.lowest_prices.sales_price) }}<span class="product-lowest-price-delivery-fee">（内送料¥{{ $n(flower.lowest_prices.delivery_fee) }}）〜</span>
      </strong>
    </div>

    <v-divider />

    <div class="my-3 d-flex align-center">
      <span class="product-earliest-delivery-date ml-2">{{ $d(date, 'select') }}</span>
    </div>

    <div class="my-3 d-flex align-center" v-if="flower.request_only">
      <div class="product-green-container">{{ $t("only_request") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flower: {
      type: Object,
      required: true
    },

    deliveryDates: {
      type: Array,
      required: true
    }
  },

  computed: {
    date() {
      return this.deliveryDates
        .slice()
        .sort((a, b) => Date.parse(a) - Date.parse(b))[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.product-detail-card {
  border: #0000001f 1px solid;
  border-radius: 5px;
  background-color: #fff;
  padding: 20px 16px 8px;
  overflow: hidden;
  min-height: 200px;

  @media screen and (max-width: 960px) {
    min-height: 0;
  }
}

.product-name {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
}

.product-lowest-price {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #FF8C71;
  line-height: 17px;
  overflow-wrap: anywhere;

  &-delivery-fee {
    font-size: 12px;
    line-height: 15px;
  }
}

.product-earliest-delivery-date {
  font-weight: bold;
  font-size: 14px;
  color: #555555;
  font-style: normal;
  line-height: 17px;
}

.product-name-lg {
  font-weight: bold;
  font-size: 20px;
}

.product-green-container {
  padding: 0 5px;
  height: 28px;
  background: #00796b;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.product-delivery-note {
  padding: 8px;
  background: #eeeeee;

  font-weight: 500;
  font-size: 14px;

  color: #01579b;
}
</style>
